// extracted by mini-css-extract-plugin
export default {"rowDescription":"ModalAddBoard_rowDescription__gC5wr","description":"ModalAddBoard_description__gHrOq","rowColor":"ModalAddBoard_rowColor__2+aI2"};